export default "__VITE_ASSET__Co4SI3sC__"